// extracted by mini-css-extract-plugin
export default {"main":"styles_main__BQOXy","inner":"styles_inner__2TOPw","innerWrapper":"styles_innerWrapper__0YGqS","caption":"styles_caption__sfBDE"};